/* BIÉDE STOQ newsletter opt-in live release v2026-08-24-4 */

(() => {
  'use strict';

  const CONTROLLER_ID = 'BiedeStoqNewsletterController';
  const TEMPLATE_ID = 'BiedeStoqNewsletterTemplate';
  const FORM_ID = 'BiedeStoqNewsletterForm';
  const EMAIL_ID = 'BiedeStoqNewsletterEmail';
  const FRAME_ID = 'BiedeStoqNewsletterTarget';
  const FRAME_NAME = 'BiedeStoqNewsletterTarget';
  const OPT_IN_ID = 'BiedeStoqNewsletterOptIn';
  const MODAL_SELECTOR = '#formContainer';

  const completedEmails = new Set();
  const inFlightEmails = new Set();
  let pendingConsent = null;
  let awaitingFrameEmail = '';
  let injectScheduled = false;
  let uiState = null;
  let currentOptInChecked = true;

  const normalizeEmail = (value) => String(value || '').trim().toLowerCase();
  const normalizeText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  function controller() {
    return document.getElementById(CONTROLLER_ID);
  }

  function getMessage(kind) {
    const source = controller();
    if (!source) return '';

    const ja = source.dataset[`${kind}Ja`] || '';
    const en = source.dataset[`${kind}En`] || '';
    return [ja, en].filter(Boolean).join(' / ');
  }

  function textFromHtml(value) {
    const template = document.createElement('template');
    template.innerHTML = String(value || '');
    return normalizeText(template.content.textContent);
  }

  function currentDuplicateMessage() {
    return textFromHtml(
      window._RestockRocketConfig?.cachedSettings?.storefront_form_duplicate_error ||
        window._StoqConfig?.cachedSettings?.storefront_form_duplicate_error ||
        '',
    );
  }

  function replaceTerms(modal) {
    const terms = modal.querySelector('#form-Terms');
    const source = controller();
    if (!terms || !source || terms.dataset.biedeNewsletterTerms === 'true') return;

    const ja = document.createElement('span');
    ja.lang = 'ja';
    ja.textContent = source.dataset.termsJa || '';

    const separator = document.createTextNode(' / ');

    const en = document.createElement('span');
    en.lang = 'en';
    en.textContent = source.dataset.termsEn || '';

    terms.replaceChildren(ja, separator, en);
    terms.classList.add('biede-stoq-newsletter-terms');
    terms.dataset.biedeNewsletterTerms = 'true';
  }

  function capturePendingConsent(event) {
    const modal = event.currentTarget.closest(MODAL_SELECTOR);
    const checkbox = modal?.querySelector(`#${OPT_IN_ID}`);
    const emailInput = modal?.querySelector('#form-Email');
    const email = normalizeEmail(emailInput?.value);

    pendingConsent = checkbox?.checked && email ? { email } : null;
  }

  function injectOptIn() {
    injectScheduled = false;

    const modal = document.querySelector(MODAL_SELECTOR);
    const button = modal?.querySelector('#form-Button');
    const template = document.getElementById(TEMPLATE_ID);
    if (!modal || !button || !template) {
      renderUiState();
      return;
    }

    if (!modal.querySelector('[data-biede-stoq-newsletter-optin]')) {
      button.before(template.content.cloneNode(true));
    }

    const checkbox = modal.querySelector(`#${OPT_IN_ID}`);
    if (checkbox && checkbox.dataset.biedeNewsletterBound !== 'true') {
      checkbox.checked = currentOptInChecked;
      checkbox.addEventListener('change', () => {
        currentOptInChecked = checkbox.checked;
      });
      checkbox.dataset.biedeNewsletterBound = 'true';
    }

    if (button.dataset.biedeNewsletterBound !== 'true') {
      button.addEventListener('click', capturePendingConsent, true);
      button.dataset.biedeNewsletterBound = 'true';
    }

    replaceTerms(modal);
    handleDuplicateRegistration(modal);
    renderUiState();
  }

  function scheduleInject() {
    if (injectScheduled) return;
    injectScheduled = true;
    window.requestAnimationFrame(injectOptIn);
  }

  function setUiState(mode, message, showAction = false) {
    uiState = { mode, message, showAction };
    renderUiState();
    window.setTimeout(renderUiState, 0);
    window.setTimeout(renderUiState, 120);
  }

  function renderUiState() {
    if (!uiState) return;

    const modal = document.querySelector(MODAL_SELECTOR);
    if (!modal) return;

    const inlineStatus = modal.querySelector('[data-biede-stoq-newsletter-status]');
    if (inlineStatus) {
      const inlineKey = `${uiState.mode}|${uiState.message}`;
      if (inlineStatus.dataset.renderKey !== inlineKey) {
        inlineStatus.textContent = uiState.message;
        inlineStatus.dataset.state = uiState.mode;
        inlineStatus.dataset.renderKey = inlineKey;
      }
    }

    const successContainer = modal.querySelector('#form-Success-Container');
    if (!successContainer) return;

    let status = successContainer.querySelector('[data-biede-stoq-newsletter-success-status]');
    if (!status) {
      status = document.createElement('div');
      status.className = 'biede-stoq-newsletter-status';
      status.dataset.biedeStoqNewsletterSuccessStatus = 'true';
      status.setAttribute('aria-live', 'polite');
      successContainer.append(status);
    }

    const renderKey = `${uiState.mode}|${uiState.message}|${uiState.showAction}`;
    if (status.dataset.renderKey === renderKey) return;

    status.replaceChildren(document.createTextNode(uiState.message));
    status.dataset.state = uiState.mode;
    status.dataset.renderKey = renderKey;

    if (uiState.showAction) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'biede-stoq-newsletter-status__button';
      button.textContent = controller()?.dataset.actionLabel || 'COMPLETE SIGN-UP';
      button.addEventListener('click', completeNewsletterSignup);
      status.append(document.createElement('br'), button);
    }
  }

  function protectedSubmit(form) {
    const submit = () => form.submit();
    const protect = window.Shopify?.captcha?.protect;

    if (typeof protect === 'function') {
      protect(form, submit);
      return;
    }

    submit();
  }

  function submitNewsletter(email) {
    const normalized = normalizeEmail(email);
    const form = document.getElementById(FORM_ID);
    const emailInput = document.getElementById(EMAIL_ID);
    if (!normalized || !form || !emailInput) return;
    if (completedEmails.has(normalized) || inFlightEmails.has(normalized)) return;

    emailInput.value = normalized;
    form.setAttribute('target', FRAME_NAME);
    inFlightEmails.add(normalized);
    awaitingFrameEmail = normalized;
    setUiState('pending', getMessage('statusPending'));
    protectedSubmit(form);
  }

  function completeNewsletterSignup() {
    const form = document.getElementById(FORM_ID);
    if (!form) return;

    form.removeAttribute('target');
    setUiState('pending', getMessage('statusPending'));
    protectedSubmit(form);
  }

  function handleFrameLoad() {
    if (!awaitingFrameEmail) return;

    const email = awaitingFrameEmail;
    const frame = document.getElementById(FRAME_ID);
    let frameDocument = null;
    let frameUrl = null;

    try {
      frameDocument = frame?.contentDocument || null;
      frameUrl = frame?.contentWindow?.location ? new URL(frame.contentWindow.location.href) : null;
    } catch (error) {
      frameDocument = null;
    }

    if (frameUrl?.href === 'about:blank') return;

    const result = frameDocument?.querySelector('[data-biede-stoq-newsletter-result]')?.dataset
      .biedeStoqNewsletterResult;
    const succeeded = result === 'success' || frameUrl?.searchParams.get('customer_posted') === 'true';

    awaitingFrameEmail = '';
    inFlightEmails.delete(email);

    if (succeeded) {
      completedEmails.add(email);
      setUiState('success', getMessage('statusSuccess'));
      return;
    }

    setUiState('action', getMessage('statusAction'), true);
  }

  function handleSubmitted(event) {
    const email = normalizeEmail(event.detail?.customer?.email);
    if (!pendingConsent || !email || pendingConsent.email !== email) {
      pendingConsent = null;
      return;
    }

    pendingConsent = null;
    submitNewsletter(email);
  }

  function handleDuplicateRegistration(modal) {
    if (!pendingConsent) return;

    const expected = currentDuplicateMessage();
    const actual = normalizeText(modal.querySelector('#form-Error-Message')?.textContent);
    if (!expected || !actual || expected !== actual) return;

    const { email } = pendingConsent;
    pendingConsent = null;
    submitNewsletter(email);
  }

  function mutationTouchesModal(record) {
    if (record.target instanceof Element && record.target.closest(MODAL_SELECTOR)) return true;

    return Array.from(record.addedNodes).some(
      (node) =>
        node instanceof Element &&
        (node.matches(MODAL_SELECTOR) || node.matches('#form-Button') || node.querySelector(MODAL_SELECTOR)),
    );
  }

  function init() {
    document.getElementById(FRAME_ID)?.addEventListener('load', handleFrameLoad);

    window.addEventListener('stoq:restock-modal:opened', () => {
      pendingConsent = null;
      uiState = null;
      currentOptInChecked = false;
      scheduleInject();
    });
    window.addEventListener('stoq:restock-modal:submitted', handleSubmitted);

    const observer = new MutationObserver((records) => {
      if (records.some(mutationTouchesModal)) scheduleInject();
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    scheduleInject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
